import React, { FC } from 'react';
import { LoadingOutlined } from '@ant-design/icons';
import { Row, Spin } from 'antd';
import clsx from 'clsx';
import styles from './loader.module.scss';

const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;

interface IProps {
  text?: string;
  inline?: boolean;
}

export const Loader: FC<IProps> = ({ text = 'Loading...', inline = false }) => (
  <Row
    align="middle"
    justify="center"
    className={clsx(styles.Loader, inline && styles.LoaderInline)}
  >
    <Spin indicator={antIcon} size="large" tip={text} />
  </Row>
);
